import { ReactNode } from 'react';
import cx from 'classnames';

import { useTailwind } from '@/hooks/useTailwind';

import { Alignment } from './API/Alignment';

interface DescriptionProps {
    className?: string;
    align?: Alignment;
    children: ReactNode;
}

const Description = ({ className = '', align = 'left', children }: DescriptionProps) => {
    const tw = useTailwind(className);

    return (
        <span className={cx('inline-block', {
            'text-lg sm:text-xl': ! tw.hasTextSize(),
            'text-neutral-600': ! tw.hasTextColor(),
            'text-left': align === 'left',
            'text-center': align === 'center',
            'text-right': align === 'right',
            [className]: Boolean(className)
        })}>
            {children}
        </span>
    );
};

export { Description };